import type { ReactNode } from "react";
import { StyleSheet, Text } from "react-native";
import type { StyleProp, TextStyle } from "react-native";

import type { UiTheme } from "../theme";

// <Eyebrow> — the small-caps-weight kicker label above a title/section
// (ink3, sm, 700, +0.4 tracking) that was hand-rolled per-file four times
// (glanceCardStyles.eyebrow, WeeklyTargetsCard.eyebrow, HomeView.groupTitle,
// ProgramComposer.eyebrow — CN-eyebrow, §CONSOLIDAMENTO). Deliberately NOT
// merged with HomeHero's own `eyebrow` style: that one tracks at +1, a
// distinct hero-only voice, not a copy of this pattern.
export function Eyebrow({
  theme,
  children,
  style,
}: {
  theme: UiTheme;
  children: ReactNode;
  style?: StyleProp<TextStyle>;
}) {
  const s = makeStyles(theme);
  return <Text style={[s.eyebrow, style]}>{children}</Text>;
}

function makeStyles(theme: UiTheme) {
  const { palette: p, typography: t } = theme;
  return StyleSheet.create({
    eyebrow: {
      color: p.ink3,
      fontSize: t.sizes.sm,
      fontWeight: "700",
      letterSpacing: 0.4,
    },
  });
}
